// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"ac607670","237":"d767f928","279":"1452f678","593":"d3ba796a","730":"d4d6f4fd"}[chunkId] + ".chunk.js";
};